import React from 'react';
import type { DeadlineStatus } from '../utils/status';
import { statusStyles } from '../utils/status';
const ORDER: DeadlineStatus[] = ['clear', 'soon', 'critical', 'done'];
interface StatusLegendProps {
  counts?: Record<DeadlineStatus, number>;
}
export function StatusLegend({
  counts
}: StatusLegendProps) {
  return <ul className="flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-119" data-mp="3scpvsk44db9l">
      {ORDER.map(status => {
      const s = statusStyles[status];
      return <li key={status} className="flex items-center gap-2" data-id="element-120" data-mp="ov7xb3a8lglu">
            <span className={`h-2 w-2 rounded-full ${s.dot}`} aria-hidden="true" data-id="element-121" data-mp="oug2vvsdlox5" />
            <span className="text-[11px] text-mute" data-id="element-122" data-mp="a5jv7zu8edx2">{s.label}</span>
            {counts && <span className="font-mono text-[10px] text-faint" data-id="element-123" data-mp="f4mwd973bzzr">{counts[status]}</span>}
          </li>;
    })}
    </ul>;
}